<apx-chart
  [series]="series"
  [chart]="chart"
  [labels]="labels"
  [colors]="colors"
  [legend]="legend"
  [plotOptions]="plotOptions"
  [responsive]="responsive"
  [dataLabels]="dataLabels"
  [tooltip]="tooltip"
>
</apx-chart>
